import { useEffect, useState } from 'react';
import HeroSection from '@/components/home/HeroSection';
import AboutSection from '@/components/home/AboutSection';
import VisionMissionSection from '@/components/home/VisionMissionSection';
import ServicesSection from '@/components/home/ServicesSection';
import ProjectsSection from '@/components/home/ProjectsSection';
import CSRPartnershipSection from '@/components/home/CSRPartnershipSection';
import TestimonialsSection from '@/components/home/TestimonialsSection';
import NewsSection from '@/components/home/NewsSection';
import GallerySection from '@/components/home/GallerySection';
import VolunteerCTASection from '@/components/home/VolunteerCTASection';
import PartnersSection from '@/components/home/PartnersSection';
import MultiCTASection from '@/components/home/MultiCTASection';
import ContactInfoSection from '@/components/home/ContactInfoSection';
import { publicApi } from '@/lib/api';
import useSEO from '@/hooks/useSEO';

export default function HomePage() {
    const [data, setData] = useState(null);
    useSEO({
        title: 'Home',
        description:
            'VVVSI Trust — Empowering lives through employment, career guidance, education, health and social welfare across Tamil Nadu & Puducherry. 2.15 lakh+ placements facilitated. 80G, 12A & CSR-1 certified.',
    });

    useEffect(() => {
        publicApi.getHome().then(setData).catch(() => {});
    }, []);

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <div data-testid="home-page">
            <HeroSection impactStats={data?.impact_stats || []} />
            <AboutSection />
            <VisionMissionSection />
            <ServicesSection services={data?.services || []} />
            <ProjectsSection projects={data?.projects || []} />
            <CSRPartnershipSection />
            <TestimonialsSection testimonials={data?.testimonials || []} />
            <NewsSection news={data?.news || []} />
            <GallerySection items={data?.gallery || []} />
            <VolunteerCTASection />
            <PartnersSection partners={data?.partners || []} />
            <MultiCTASection />
            <ContactInfoSection />
        </div>
    );
}
